import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { AddToCartComponent } from '../../../app/content/layout/components/product/add-to-cart/add-to-cart.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct, createOutOfStockProduct, createPreorderProduct, createLastBottlesProduct } from '../../_mocks';

const meta: Meta<AddToCartComponent> = {
  title: 'Molecules/Product/Add To Cart',
  component: AddToCartComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Add-to-cart form with quantity input, like button, and cart integration.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<AddToCartComponent>;

export const Default: Story = {
  args: {
    product: createDamilanoBarberaProduct() as any,
    eventSourceName: 'storybook',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByRole('button', { name: /læg i kurv/i })).toBeInTheDocument();
  },
};

export const WithHitPosition: Story = {
  args: {
    product: createDamilanoBarberaProduct() as any,
    eventSourceName: 'search-results',
    hitPosition: 3,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByRole('button', { name: /læg i kurv/i })).toBeInTheDocument();
  },
};

export const HideLikeButton: Story = {
  args: {
    product: createDamilanoBarberaProduct() as any,
    eventSourceName: 'storybook',
    hideLikeButton: true,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByRole('button', { name: /læg i kurv/i })).toBeInTheDocument();
    await expect(canvasElement.querySelector('.user-like')).toBeFalsy();
  },
};

export const OutOfStock: Story = {
  args: {
    product: createOutOfStockProduct() as any,
    eventSourceName: 'storybook',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/udsolgt/i)).toBeInTheDocument();
  },
};

export const Preorder: Story = {
  args: {
    product: createPreorderProduct() as any,
    eventSourceName: 'storybook',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('form[add-to-cart]')).toBeTruthy();
  },
};

export const DefaultQuantity6: Story = {
  args: {
    product: createDamilanoBarberaProduct({ defaultQuantity: 6 }) as any,
    eventSourceName: 'storybook',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByRole('button', { name: /læg i kurv/i })).toBeInTheDocument();
  },
};

export const LastBottles: Story = {
  args: {
    product: createLastBottlesProduct() as any,
    eventSourceName: 'storybook',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByRole('button', { name: /læg i kurv/i })).toBeInTheDocument();
  },
};
